"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Toast", {
  enumerable: true,
  get: function get() {
    return _Toast["default"];
  }
});
Object.defineProperty(exports, "useToast", {
  enumerable: true,
  get: function get() {
    return _hooks.useToast;
  }
});
Object.defineProperty(exports, "ToastBody", {
  enumerable: true,
  get: function get() {
    return _components.ToastBody;
  }
});
exports.ToastProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactProvider = require("@trycourier/react-provider");

var _styledComponents = require("styled-components");

var _defaults = require("./defaults");

var _Toast = _interopRequireDefault(require("./components/Toast"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _hooks = require("./hooks");

var _components = require("./components");

var ToastProvider = function ToastProvider(_ref) {
  var _config$theme;

  var children = _ref.children,
      transport = _ref.transport,
      clientKey = _ref.clientKey,
      config = _ref.config,
      userId = _ref.userId;
  config = (0, _react.useMemo)(function () {
    var _config;

    return (0, _deepExtend["default"])({}, _defaults.defaultConfig, (_config = config) !== null && _config !== void 0 ? _config : {});
  }, [config]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: (_config$theme = config.theme) !== null && _config$theme !== void 0 ? _config$theme : {}
  }, /*#__PURE__*/_react["default"].createElement(_reactProvider.CourierProvider, {
    clientKey: clientKey,
    userId: userId,
    transport: transport
  }, /*#__PURE__*/_react["default"].createElement(_Toast["default"], config), children));
};

exports.ToastProvider = ToastProvider;